import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import KakaoAdfit1 from '../KakaoAdfit/KakaoAdfit1';
import KakaoAdfit2 from '../KakaoAdfit/KakaoAdfit2';
import KakaoAdfit3 from '../KakaoAdfit/KakaoAdfit3';
import KakaoAdfit4 from '../KakaoAdfit/KakaoAdfit4';
import { ReactComponent as GithubImg } from '../common/image/github.svg';
import { ReactComponent as InstagramImg } from '../common/image/instagram.svg';
import { ReactComponent as TistoryImg } from '../common/image/tistory.svg';
import { ReactComponent as LinkImg } from '../common/image/link.svg';
import { isMobile } from '../common/style';
import axios from 'axios';

type ProjectType = {
  id: number;
  img: string;
  title: string;
  description: string;
  link: string;
};

const DevPage: React.FC = () => {
  const [data, setData] = useState<ProjectType[]>([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://projectapi-94fc6-default-rtdb.firebaseio.com/project.json`,
      );
      const responseData = response.data;
      if (responseData) {
        setData(responseData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Center>
      <h1>밸런스게임</h1>
      <Container>
        <h2>다른 프로젝트 보러가기</h2>
        <ScrollDiv>
          {data.map((dev: ProjectType) => (
            <GameDiv key={dev.id} onClick={() => window.open(dev.link)}>
              <img src={dev.img} alt={dev.title} />
              <DesDiv>
                <h3>{dev.title}</h3>
                <h4>{dev.description}</h4>
              </DesDiv>
            </GameDiv>
          ))}
        </ScrollDiv>
        <LinkDiv>
          <GithubImg
            className="icon"
            style={{ marginRight: '11px' }}
            onClick={() => window.open('https://github.com/rlotr02')}
          />
          <InstagramImg
            className="icon"
            style={{ marginRight: '12px' }}
            onClick={() => window.open('https://www.instagram.com/rlotr.dev')}
          />
          <TistoryImg
            className="icon"
            style={{ marginRight: '6px' }}
            onClick={() => window.open('https://rlotr.tistory.com')}
          />
          <LinkImg
            className="icon"
            onClick={() => window.open('https://litt.ly/rlotr02')}
          />
        </LinkDiv>
        <h6 onClick={() => window.open('https://github.com/rlotr02')}>
          ⓒ 2023. rlotr02 All rights reserved.
        </h6>
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default DevPage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #4da082;

    margin-top: 63px;
    margin-bottom: 40px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 30px;
    }
  }
`;

const Container = styled.div`
  margin-bottom: 30px;
  width: 800px;
  height: 530px;

  border-radius: 60px;
  border: 3px solid #3d6c5b;
  background: #dcf0e9;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${isMobile} {
    width: 300px;
    height: 350px;
    border-radius: 30px;
    margin-bottom: 15px;
    border: 2px solid #3d6c5b;
  }

  h2 {
    color: #3e6a55;
    font-family: GmarketSansBold;
    font-size: 23px;
    font-weight: 700;
    margin: 30px 0;

    ${isMobile} {
      font-size: 17px;
      margin: 17px 0;
    }
  }

  h6 {
    color: #586f64;
    font-family: GmarketSansLight;
    font-size: 13px;
    font-weight: 300;
    margin-top: 10px;
    cursor: pointer;

    ${isMobile} {
      font-size: 10px;
      margin-top: 4px;
    }
  }
`;

const ScrollDiv = styled.div`
  width: 500px;
  height: 318px;
  overflow: auto;
  margin-bottom: 20px;

  ${isMobile} {
    width: 250px;
    height: 221px;
    margin-bottom: 8px;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b9d1c9;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const GameDiv = styled.div`
  width: 430px;
  height: 110px;
  border-radius: 30px;
  border: 3px solid #3d6c5b;
  background: #fff;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;

  ${isMobile} {
    width: 210px;
    height: 80px;
    border-radius: 22px;
    margin-bottom: 10px;
    border: 2px solid #3d6c5b;
  }

  &:hover {
    background: #e2f3de;
  }

  img {
    float: left;
    margin-left: 14px;

    ${isMobile} {
      margin-left: 3px;
      width: 70px;
    }
  }
`;

const DesDiv = styled.div`
  margin-left: 8px;
  text-align: left;

  ${isMobile} {
    margin-left: 0px;
  }

  h3 {
    color: #31452a;
    font-family: GmarketSansBold;
    font-size: 19px;
    font-weight: 700;

    ${isMobile} {
      font-size: 12px;
    }
  }

  h4 {
    margin-top: 6px;
    color: #536f4a;
    font-family: GmarketSansMedium;
    font-size: 15px;
    font-weight: 500;
    line-height: 160%;
    word-break: keep-all;

    ${isMobile} {
      font-size: 10px;
      line-height: 150%;
    }
  }
`;

const LinkDiv = styled.div`
  .icon {
    width: 32px;
    height: 32px;
    fill: #8c9f96;
    cursor: pointer;

    &:hover {
      fill: #3d6c5b;
    }

    ${isMobile} {
      width: 23px;
      height: 23px;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 100px;
  margin-right: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 100px;
  margin-left: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
